/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */

export const Wrap = styled.div`
    display: flex;    
    font-size: 8px;
    .coordinates1{
        position: relative;
        top: -0.5%;
    }
    .coordinates2{
        position: relative;
        top: 11.5%;        
    }
    .coordinates3{
        position: relative;
        top: 24%;        
    }
    .coordinates4{
        position: relative;
        top: 36.5%;        
    }
    .coordinates5{
        position: relative;
        top: 48.5%;        
    }
    .coordinates6{
        position: relative;
        top: 61%;        
    }
    .coordinates7{
        position: relative;
        top: 73.5%;        
    }
    .coordinates8{
        position: relative;
        top: 85.5%;        
    }
`;